export const toneOptions = [
    "Professional",
    "Modern",
    "Creative",
    "Luxury",
    "Friendly",
    "Bold"
];

export const industryOptions = [
    "Education",
    "Real Estate",
    "E-commerce",
    "Healthcare",
    "Legal",
    "Software",
    "Construction",
    "Home Services",
    "Consulting"
];

export const subIndustryOptionsByIndustry = {
    Education: [
        "Sports Academy",
        "Coaching Institute",
        "School",
        "Online Course"
    ],
    "Real Estate": [
        "Property Agency",
        "Real Estate Portal",
        "Property Developer"
    ],
    "E-commerce": [
        "Online Store",
        "Fashion Store",
        "Beauty Store",
        "Electronics Store"
    ],
    Healthcare: [
        "Clinic",
        "Dental Clinic",
        "Medical Practice"
    ],
    Legal: [
        "Law Firm",
        "Legal Consultant"
    ],
    Software: [
        "SaaS Platform",
        "AI Software",
        "CRM Software"
    ],
    Construction: [
        "Construction Company",
        "Interior Design",
        "Architecture Studio"
    ],
    "Home Services": [
        "Local Service Business",
        "Cleaning Service",
        "Repair Service"
    ],
    Consulting: [
        "Business Consulting",
        "Marketing Agency",
        "IT Consulting"
    ]
};

export const ctaOptions = [
    "Book a Call",
    "Get a Quote",
    "Contact Us",
    "Schedule Consultation",
    "Start Free Trial",
    "Request Demo",
    "Get Started",
    "Buy Now",
    "Send Inquiry",
    "View Portfolio",
    "See Pricing",
    "WhatsApp Now",
    "Download Brochure",
    "Join Now"
];

export const brandStyleOptions = [
    "Premium",
    "Minimal",
    "Corporate",
    "Bold",
    "Luxury",
    "Modern",
    "Futuristic",
    "Elegant",
    "Friendly",
    "High-Trust",
    "Startup",
    "Creative"
];

export const pricePositioningOptions = [
    "Budget",
    "Affordable",
    "Mid-Market",
    "Premium",
    "Luxury"
];

export const goalOptions = [
    "Generate Leads",
    "Book Appointments",
    "Drive Sales",
    "Showcase Portfolio",
    "Build Trust",
    "Brand Awareness",
    "Get Demo Requests",
    "Capture Emails",
    "Promote Service",
    "Launch Product",
    "Drive WhatsApp Inquiries",
    "Increase Phone Calls"
];

export const websiteTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Property Portal / Listings", value: "portal" },
    { label: "Business / Company Website", value: "company" },
    { label: "Builder / Developer", value: "builder" },
    { label: "Academy / Institute", value: "academy" },
    { label: "Store / Shop", value: "store" },
    { label: "Agency", value: "agency" },
    { label: "SaaS Product / Platform", value: "saas" },
    { label: "Clinic / Healthcare Center", value: "clinic" },
    { label: "Law Firm / Legal Practice", value: "legal-firm" }
];

export const websiteModeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Search & Discovery", value: "search-discovery" },
    { label: "Lead Generation", value: "lead-generation" },
    { label: "Brand Showcase", value: "brand-showcase" },
    { label: "Catalog / Browse", value: "catalog" },
    { label: "Admissions / Enquiries", value: "admissions" },
    { label: "Demo / Trial Conversion", value: "demo-conversion" },
    { label: "Appointment Booking", value: "appointment-booking" },
    { label: "Consultation First", value: "consultation-first" }
];

export const entityTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Properties / Listings", value: "property" },
    { label: "Programs / Courses", value: "program" },
    { label: "Products", value: "product" },
    { label: "Services", value: "service" },
    { label: "Features / Modules", value: "feature" },
    { label: "Doctors / Treatments", value: "healthcare" },
    { label: "Practice Areas / Lawyers", value: "legal" }
];

export const locationFocusOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "City Focused", value: "city-first" },
    { label: "Area / Locality Focused", value: "locality-first" },
    { label: "Statewide", value: "statewide" },
    { label: "National", value: "national" }
];

export const websiteFeelOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Utility Dense", value: "utility-dense" },
    { label: "Premium Minimal", value: "premium-minimal" },
    { label: "Trust Focused", value: "trust-heavy" },
    { label: "Conversion Focused", value: "conversion-first" },
    { label: "Product Led", value: "product-led" },
    { label: "Care Focused", value: "care-first" },
    { label: "Authority Focused", value: "authority-first" }
];

export const getRecommendedPages = (
    industry,
    subIndustry,
    businessModel = "",
    primaryWebsiteMode = ""
) => {
    const text = `${industry} ${subIndustry} ${businessModel} ${primaryWebsiteMode}`.toLowerCase();

    if (
        text.includes("real estate") ||
        text.includes("property") ||
        text.includes("portal") ||
        text.includes("listing") ||
        text.includes("search-discovery")
    ) {
        return ["Home", "Listings", "Localities", "Contact"];
    }

    if (
        text.includes("sports") ||
        text.includes("academy") ||
        text.includes("training") ||
        text.includes("education") ||
        text.includes("school") ||
        text.includes("course") ||
        text.includes("admissions")
    ) {
        return ["Home", "Programs", "Coaches", "Contact"];
    }

    if (
        text.includes("e-commerce") ||
        text.includes("ecommerce") ||
        text.includes("store") ||
        text.includes("shop") ||
        text.includes("catalog")
    ) {
        return ["Home", "Products", "Collections", "Contact"];
    }

    if (
        text.includes("saas") ||
        text.includes("software") ||
        text.includes("platform") ||
        text.includes("crm") ||
        text.includes("automation")
    ) {
        return ["Home", "Features", "Pricing", "Contact"];
    }

    if (
        text.includes("healthcare") ||
        text.includes("clinic") ||
        text.includes("medical") ||
        text.includes("dental") ||
        text.includes("doctor") ||
        text.includes("wellness")
    ) {
        return ["Home", "Treatments", "Doctors", "Contact"];
    }

    if (
        text.includes("legal") ||
        text.includes("law") ||
        text.includes("law firm") ||
        text.includes("advocate") ||
        text.includes("attorney")
    ) {
        return ["Home", "Practice Areas", "Team", "Contact"];
    }

    return ["Home", "About", "Services", "Contact"];
};